export default {
    /* GET */
    EVENTS_GET_FILTERS: 'EVENTS_GET_FILTERS',
    EVENTS_GET_FILTERS_SUCCESS: 'EVENTS_GET_FILTERS_SUCCESS',
    EVENTS_GET_FILTERS_ERROR: 'EVENTS_GET_FILTERS_ERROR',
    EVENTS_GET_FILTERS_CLEAR: 'EVENTS_GET_FILTERS_CLEAR',
    /* SET */
    EVENTS_SET_FILTERS: 'EVENTS_SET_FILTERS',
    EVENTS_SET_FILTERS_SUCCESS: 'EVENTS_SET_FILTERS_SUCCESS',
    EVENTS_SET_FILTERS_ERROR: 'EVENTS_SET_FILTERS_ERROR',
    EVENTS_SET_FILTERS_CLEAR: 'EVENTS_SET_FILTERS_CLEAR',
};



// WEBPACK FOOTER //
// ./src/constants/events/filtersTypes.js